import Profile from "../components/MerchantEmployees/Profile"
import Nav from "../components/Nav/nav";
import Whatsapp from "../Whatsapp/whatsapp";
const ListingPage = () => {
  return (
    <div>
      <Nav />
      <Profile />
      <Whatsapp/>
    </div>
  );
};

export default ListingPage;
